@import "config";

.container {
	width: 100%;
	height: 100%;

	border-radius: $border-radius-md;
	box-shadow: $shadow-level-1;

	padding: $spacing-inset-sm;
}
